<template>
  <div class="mcontainer">
    <div class="breadcrumb-area py-0">
      <div class="breadcrumb">
        <ul class="m-0">
          <li><router-link to="/app/admin/events">Events Admin</router-link></li>
          <li class="active"><a href="#">Edit Event</a></li>
        </ul>
      </div>
    </div>
    <div class="max-w-5xl m-auto shadow-md rounded-md bg-white mt-5" v-if="!loadingDetail">
      <form @submit.prevent="actionSubmit()">
        <div class="text-center border-b py-4">
          <h3 class="font-bold text-lg">Edit Event</h3>
        </div>
        <div class="p-7 space-y-5">
          <div>
            <label class="font-semibold">Judul *</label><br>
            <input class="form-control" v-model="form.title" type="text" required placeholder="Judul event">
          </div>
          <div>
            <label class="font-semibold">Deskripsi</label><br>
            <Editor v-model="form.description" />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label class="font-semibold">Lokasi</label><br>
              <input class="form-control" v-model="form.location" type="text" placeholder="Lokasi event">
            </div>
            <div>
              <label class="font-semibold">Tanggal & Waktu</label><br>
              <input class="form-control" v-model="form.event_date" type="datetime-local">
            </div>
          </div>
          <div>
            <label class="font-semibold">URL Pendaftaran</label><br>
            <input class="form-control" v-model="form.register_url" type="url" placeholder="https://...">
          </div>
          <div>
            <label class="font-semibold">Tampilkan tombol Register</label>
            <div class="flex items-center gap-2 mt-1">
              <input type="checkbox" v-model="form.show_button" id="show_button" class="checkbox-register">
              <label for="show_button" class="cursor-pointer text-sm font-normal">Centang untuk menampilkan</label>
            </div>
          </div>
          <div>
            <label class="font-semibold">Status</label><br>
            <select class="form-control" v-model="form.status">
              <option value="active">Aktif</option>
              <option value="inactive">Tidak Aktif</option>
            </select>
          </div>
          <div>
            <label class="font-semibold">Gambar</label><br>
            <div class="image-uploader">
              <input type="file" ref="imageInput" @change="onFileSelected" accept="image/*">
              <span @click="$refs.imageInput.click()"><Icon icon="bi:cloud-upload" /></span>
              <img :src="preview || form.image" alt="Preview" class="w-80 max-h-48 object-cover rounded">
            </div>
          </div>
        </div>
        <div class="border-t flex justify-center gap-3 border-gray-100 p-6">
          <router-link to="/app/admin/events" class="btn btn-secondary">Batal</router-link>
          <button type="submit" class="btn btn-primary" :disabled="submitting">
            <span v-if="!submitting">Update Event</span>
            <b-spinner v-if="submitting" small />
          </button>
        </div>
      </form>
    </div>
    <div v-else class="p-8 text-center"><b-spinner /> Loading...</div>
  </div>
</template>

<script>
import axios from 'axios'
import { Icon } from '@iconify/vue2'
import Editor from '@/components/Editor'

export default {
  name: 'EventAdminEdit',
  components: { Icon, Editor },
  data () {
    return {
      form: {
        title: '',
        description: '',
        location: '',
        event_date: '',
        register_url: '',
        show_button: true,
        status: 'active',
        image: null
      },
      preview: '',
      submitting: false,
      loadingDetail: true
    }
  },
  created () {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail () {
      this.loadingDetail = true
      try {
        const { data } = await axios.get(`/admin/events/${this.$route.params.id}`)
        this.setForm(data)
      } catch (e) {
        this.$swal({ icon: 'error', title: 'Error', text: 'Gagal memuat data' }).then(() => {
          this.$router.push({ name: 'EventAdmin' })
        })
      } finally {
        this.loadingDetail = false
      }
    },
    setForm (item) {
      this.form = {
        id: item.id,
        title: item.title,
        description: item.description || '',
        location: item.location || '',
        event_date: item.event_date ? item.event_date.slice(0, 16) : '',
        register_url: item.register_url || '',
        show_button: item.show_button !== false && item.show_button !== 0,
        status: item.status || 'active',
        image: item.image
      }
    },
    onFileSelected (e) {
      const file = e.target.files[0]
      if (file) {
        this.form.image = file
        this.preview = URL.createObjectURL(file)
      }
    },
    async actionSubmit () {
      this.submitting = true
      try {
        const formData = new FormData()
        formData.append('title', this.form.title)
        formData.append('description', this.form.description)
        formData.append('location', this.form.location)
        formData.append('event_date', this.form.event_date)
        formData.append('register_url', this.form.register_url)
        formData.append('show_button', this.form.show_button ? 1 : 0)
        formData.append('status', this.form.status)
        if (this.form.image && this.form.image instanceof File) {
          formData.append('image', this.form.image)
        }

        await axios.post(`/admin/events/${this.form.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })

        this.$swal({
          icon: 'success',
          title: 'Berhasil',
          text: 'Event berhasil diupdate'
        }).then(() => {
          this.$router.push({ name: 'EventAdmin' })
        })
      } catch (e) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: e.response?.data?.message || 'Gagal update event'
        })
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.form-control { width: 100%; padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 8px; }
.image-uploader { display: flex; flex-direction: column; gap: 8px; }
.image-uploader span { cursor: pointer; color: #3b82f6; }
.btn { padding: 8px 16px; border-radius: 8px; text-decoration: none; display: inline-flex; align-items: center; gap: 6px; }
.btn-primary { background: #2563eb; color: #fff; border: none; cursor: pointer; }
.btn-secondary { background: #e5e7eb; color: #374151; }
</style>
